
    const data = {"name":"src/core/icons/send-variant","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M3 20v-6l8-2-8-2V4l19 8Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            